import { useEffect, useState } from 'react';
import { useLocation } from 'wouter';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import apiService from 'Services/apiService';
import e from './style.module.css';
import { ModalLogin } from './Modal/ModalLogin';
import segBuild from 'assets/img/segurnetB.svg';
import circular from 'assets/img/comunications/circular-05-2025.jpeg';
import AlertNotification, {IAlert} from "components/common/AlertNotification/AlertNotification";
import ModalMultiAccounts from 'components/common/Modals/ModalMultiAccounts';
import Loading from 'components/common/Loading/Loading';
import { useMenu } from 'context/MenuContext';
import { Modal, Button, Form } from 'react-bootstrap';

export const Login = () => {
  const [, setLocation] = useLocation();
  const token = localStorage.getItem('user');
  const { updateMenus } = useMenu();
  const [alert, setAlert] =  useState<IAlert>({ show: false, title: '', details: '', variant: 'Danger' });
  const [loading, setLoading] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [multiAccounts, setMultiAccounts] = useState(false);
  const [showLoadingComponent, setShowLoadingComponent] = useState(false);
  
  //  Esto se debe eliminar cuando se haga el comunications por api
  // ------ INICIO
  const [showResolutionModal, setShowResolutionModal] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(
    localStorage.getItem('hideResolutionModal') === 'true'
  );

  useEffect(() => {
    if (!dontShowAgain) {
      setShowResolutionModal(true);
    }
    }, [dontShowAgain]);
    const handleCloseResolution = () => {
    setShowResolutionModal(false);
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setDontShowAgain(checked);
    localStorage.setItem('hideResolutionModal', checked ? 'true' : 'false');
  };

  // ------ FIN


  useEffect(() => {
    if (token) {
      setLocation('/');
    }
  }, [token, setLocation]);

  const resetAlert = () => {
    setAlert(prev => ({ ...prev, show: false }));
  };

  const switchTenant = (clientCod: string) => {
    setShowLoadingComponent(true);
    apiService({
      name: 'switchTenan',
      queryParams: { _codigoCliente: clientCod },
      useSpecialToken: true,
      onSuccess: ({response}) => {
        // Procesar la respuesta
        const user = {
          codTipoCliente: response?.user?._codigoCliente,
          codUsuario: response?.user?._codigoCliente,
          correo: response?.user?._email,
          ...response
        }
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('cliCod', JSON.stringify(clientCod));
        updateMenus(user?.array_menus)
      },
      onError: (error) => {
        setAlert({
          show: true,
          title: 'Error realizar la acción.',
          details: error?.message,
          variant: 'Danger'
        });
      },
      onFinally() {
        setShowLoadingComponent(false);
        const originalPath = localStorage.getItem('originalPath') || '/';
        setLocation(originalPath);
      }
    });
  }
  
  const handleLogin = (username: string, password: string, saveUser: boolean) => {
    setLoading(true);
    apiService({
      name: 'login',
      body: { userN: username, userC: password, saveUser: saveUser },
      onSuccess: ({response}) => {
        if (response.user?._grupo === "Productor") {
          switchTenant(response.user._codigoProductor)
          return
        }
        if (response.user?._tipoUsuario !== "Individual") {
          switchTenant(response.array_clients[0]._codigoCliente)
          return
        }
        if (response.array_clients.length > 1) {
          setShowLogin(false);
          setMultiAccounts(true);
        }
      },
      onError: (e) => {
        const error = typeof e === 'string' ? e : e.response
        setAlert({
          show: true,
          title: 'Error al inciar sesión',
          details: error || 'Contraseña o usuario incorrectos',
          variant: 'Danger'
        })
      },
      onFinally() {
        setLoading(false);
      }
    });
  };

  

  return (
    <>
      {showLoadingComponent && <Loading />}
      {/* ——— Modal de la Resolución - Esto se debe eliminar cuando se haga el comunications por api ——— */}
      <Modal
        show={showResolutionModal}
        onHide={handleCloseResolution}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Aviso Importante
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={e.modal_comunincations}>
          <h5>Resolución SIS Núm. 05-2025</h5>
          <p>
            La Superintendencia de Seguros informa que a partir del 1 de julio de 2025
            entran en vigor los nuevos límites mínimos obligatorios de cobertura
            en materia de Responsabilidad Civil para el seguro de vehículos de motor.
            (Resolución Núm. 05-2025, de fecha 23/05/2025).
          </p>
          <a
            href={circular}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'block', textAlign: 'center' }}
          >
            <img
              src={circular}
              alt="Circular SIS Resolución 05-2025"
              className="img-fluid mb-3"
              style={{ cursor: 'pointer', maxHeight: '450px' }}
            />
          </a>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex justify-content-between w-100'>
            <div className='mr-auto'>
              <Form.Check
                type="checkbox"
                label="No volver a mostrar este mensaje"
                checked={dontShowAgain}
                onChange={handleCheckboxChange}
              />
            </div>
            <div>
              <Button variant="secondary" onClick={handleCloseResolution}>
                Cerrar
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
      {/* FIN */}

      <Container className={e.login__ctn}>
        <Row>
          <img
            src={segBuild}
            alt='Vector oficina principal de Segurnet'
            className={`center ${e.login__img}`}
          />
        </Row>
        <ModalLogin
          show={showLogin}
          onSubmit={handleLogin}
          disableBtn={loading}
        />
        <ModalMultiAccounts
          show={multiAccounts}
          switchT={switchTenant}
        />
      </Container>
      <AlertNotification
        show={alert?.show}
        title= {alert?.title}
        details= {alert?.details}
        variant={alert?.variant}
        onClose={resetAlert}
      />
    </>
  );
};